import { Flex } from "antd";
import { FC } from "react";

import EmptyGif from "@/assets/images/empty-markets.gif";
import { PrimaryText } from "@/shared/ui/Typography";

import { StyledEmptyMarketGif } from "./Styled";

interface EmptyPointsProps {
    text: string;
}

export const EmptyPoints: FC<EmptyPointsProps> = ({ text }) => (
    <Flex vertical gap={16} align="center">
        <PrimaryText textAlign="center">{text}</PrimaryText>

        <StyledEmptyMarketGif src={EmptyGif} alt="empty markets" />
    </Flex>
);
